webpackJsonp([104158497352714],{

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SignUpLink = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(25);
	
	var _firebase = __webpack_require__(22);
	
	var _routes = __webpack_require__(32);
	
	var routes = _interopRequireWildcard(_routes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var updateByPropertyName = function updateByPropertyName(propertyName, value) {
	  return function () {
	    var _ref;
	
	    return _ref = {}, _ref[propertyName] = value, _ref;
	  };
	};
	
	var INITIAL_STATE = {
	  username: '',
	  email: '',
	  passwordOne: '',
	  passwordTwo: '',
	  error: null
	};
	
	var SignUpForm = function (_Component) {
	  _inherits(SignUpForm, _Component);
	
	  function SignUpForm(props) {
	    _classCallCheck(this, SignUpForm);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.onSubmit = function (event) {
	      var _this$state = _this.state,
	          username = _this$state.username,
	          email = _this$state.email,
	          passwordOne = _this$state.passwordOne;
	      var history = _this.props.history;
	
	
	      _firebase.auth.doCreateUserWithEmailAndPassword(email, passwordOne).then(function (authUser) {
	        // Create a user in your own accessible Firebase Database too
	        _firebase.db.doCreateUser(authUser.uid, username, email).then(function () {
	          _this.setState(function () {
	            return _extends({}, INITIAL_STATE);
	          });
	          history.push(routes.HOME);
	        }).catch(function (error) {
	          _this.setState(updateByPropertyName('error', error));
	        });
	      }).catch(function (error) {
	        _this.setState(updateByPropertyName('error', error));
	      });
	
	      event.preventDefault();
	    };
	
	    _this.state = _extends({}, INITIAL_STATE);
	    return _this;
	  }
	
	  SignUpForm.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _firebase.firebase.auth.onAuthStateChanged(function (authUser) {
	      authUser && _this2.props.history.push(routes.LESSONS);
	    });
	  };
	
	  SignUpForm.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        username = _state.username,
	        email = _state.email,
	        passwordOne = _state.passwordOne,
	        passwordTwo = _state.passwordTwo,
	        error = _state.error;
	
	
	    var isInvalid = passwordOne !== passwordTwo || passwordOne === '' || username === '' || email === '';
	
	    return _react2.default.createElement(
	      'form',
	      { onSubmit: this.onSubmit },
	      _react2.default.createElement('input', {
	        value: username,
	        onChange: function onChange(event) {
	          return _this3.setState(updateByPropertyName('username', event.target.value));
	        },
	        type: 'text',
	        placeholder: 'Full Name',
	        style: { display: 'block', marginBottom: 15, paddingLeft: 10 }
	      }),
	      _react2.default.createElement('input', {
	        value: email,
	        onChange: function onChange(event) {
	          return _this3.setState(updateByPropertyName('email', event.target.value));
	        },
	        type: 'text',
	        placeholder: 'Email Address',
	        style: { display: 'block', marginBottom: 15, paddingLeft: 10 }
	      }),
	      _react2.default.createElement('input', {
	        value: passwordOne,
	        onChange: function onChange(event) {
	          return _this3.setState(updateByPropertyName('passwordOne', event.target.value));
	        },
	        type: 'password',
	        placeholder: 'Password',
	        style: { display: 'block', marginBottom: 15, paddingLeft: 10 }
	      }),
	      _react2.default.createElement('input', {
	        value: passwordTwo,
	        onChange: function onChange(event) {
	          return _this3.setState(updateByPropertyName('passwordTwo', event.target.value));
	        },
	        type: 'password',
	        placeholder: 'Confirm Password',
	        style: { display: 'block', marginBottom: 15, paddingLeft: 10 }
	      }),
	      _react2.default.createElement(
	        'button',
	        { disabled: isInvalid, type: 'submit' },
	        'Sign Up'
	      ),
	      error && _react2.default.createElement(
	        'p',
	        null,
	        error.message
	      )
	    );
	  };
	
	  return SignUpForm;
	}(_react.Component);
	
	var SignUpLink = function SignUpLink() {
	  return _react2.default.createElement(
	    'p',
	    null,
	    'Don\'t have an account? ',
	    _react2.default.createElement(
	      _reactRouterDom.Link,
	      { to: routes.SIGN_UP },
	      'Sign Up'
	    )
	  );
	};
	
	exports.default = (0, _reactRouterDom.withRouter)(SignUpForm);
	exports.SignUpLink = SignUpLink;

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(25);
	
	var _SignUp = __webpack_require__(99);
	
	var _SignUp2 = _interopRequireDefault(_SignUp);
	
	var _routes = __webpack_require__(32);
	
	var routes = _interopRequireWildcard(_routes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SignUpPage = function SignUpPage() {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#fff',
	        margin: 'auto',
	        boxShadow: '0 0 0 1px rgba(16,22,26,.1),0 4px 8px rgba(16,22,26,.2),0 18px 46px 6px rgba(16,22,26,.2)',
	        borderRadius: 8,
	        padding: 20,
	        maxWidth: 500
	      }
	    },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Sign Up'
	    ),
	    _react2.default.createElement(_SignUp2.default, null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Already have an account? ',
	      _react2.default.createElement(
	        _reactRouterDom.Link,
	        { to: routes.SIGN_IN },
	        'Sign In'
	      )
	    )
	  );
	};
	
	exports.default = SignUpPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-signup-js-683d9a753b6eb12cc63e.js